export const UPLOAD_PATHS = {
  CV: '/upload/cv',
  ELIGIBILITY_PROOF: '/upload/eligibility_proof',
  DIVERSITY_ASSESSMENT_DOCUMENTS: '/upload/diversity_assessment_documents',
  ENROLLMENT_PLAN_FILE: '/upload/enrollment_plan_file',
  DIVERSITY_FILE: '/upload/diversity_file',
};

export interface FileUploadService {
  uploadCv: (file: File) => Promise<string>;
  uploadEligibilityProof: (file: File) => Promise<string>;
  uploadEnrollmentPlanFile: (file: File) => Promise<string>;
  uploadDiversityFile: (file: File) => Promise<string>;
}

export const fileStorageServiceFactory = ({
  uploadCv = async () => 'path',
  uploadEligibilityProof = async () => 'path',
  uploadEnrollmentPlanFile = async () => 'path',
  uploadDiversityFile = async () => 'path',
}: Partial<FileUploadService> = {}): FileUploadService => ({
  uploadCv,
  uploadEligibilityProof,
  uploadEnrollmentPlanFile,
  uploadDiversityFile,
});

export const buildNoopFileUploadService = (): FileUploadService => ({
  uploadCv: async () => 'path',
  uploadEligibilityProof: async () => 'path',
  uploadEnrollmentPlanFile: async () => 'path',
  uploadDiversityFile: async () => 'path',
});
